export default {
  // Service Configuration Management Page
  'pages.service-config.title': 'Amount Configuration',
  'pages.service-config.subTitle': 'Manage property fee collection items and price configurations',
  'pages.service-config.breadcrumb.feeManagement': 'Fee Management',
  'pages.service-config.breadcrumb.moneyConfig': 'Amount Configuration',
  'pages.service-config.detail.title': 'Amount Configuration Details',

  // List Page
  'pages.service-config.table.title': 'Amount Configuration List',
  'pages.service-config.table.create': 'Create Configuration',
  'pages.service-config.table.batchDelete': 'Batch Delete',
  'pages.service-config.table.confirmDelete': 'Are you sure you want to delete this configuration?',
  'pages.service-config.table.confirmBatchDelete': 'Are you sure you want to batch delete the selected configurations?',
  'pages.service-config.table.deleteSuccess': 'Deleted successfully',
  'pages.service-config.table.deleteFailed': 'Delete failed',
  'pages.service-config.table.batchDeleteSuccess': 'Batch delete successful',
  'pages.service-config.table.batchDeleteFailed': 'Batch delete failed',
  'pages.service-config.table.getDetailFailed': 'Failed to get details',
  'pages.service-config.table.createSuccess': 'Created successfully',
  'pages.service-config.table.updateSuccess': 'Updated successfully',
  'pages.service-config.table.createFailed': 'Create failed',
  'pages.service-config.table.updateFailed': 'Update failed',
  'pages.service-config.table.submitFailed': 'Operation failed',
  'pages.service-config.table.selectedItems': 'Selected',
  'pages.service-config.table.items': 'items',
  'pages.service-config.table.cancelSelection': 'Cancel selection',
  'pages.service-config.table.close': 'Close',

  // Table Columns
  'pages.service-config.table.columns.feeType': 'Fee Type',
  'pages.service-config.table.columns.icon': 'Icon',
  'pages.service-config.table.columns.name': 'Service Name',
  'pages.service-config.table.columns.introduction': 'Description',
  'pages.service-config.table.columns.status': 'Status',
  'pages.service-config.table.columns.batchCreate': 'Batch Create',
  'pages.service-config.table.columns.sort': 'Sort',
  'pages.service-config.table.columns.createdTime': 'Created Time',
  'pages.service-config.table.columns.operations': 'Operations',
  'pages.service-config.table.columns.edit': 'Edit',
  'pages.service-config.table.columns.delete': 'Delete',

  // Detail Modal
  'pages.service-config.detail.modal.title': 'Configuration Details',
  'pages.service-config.detail.feeType': 'Fee Type',
  'pages.service-config.detail.unitPrice': 'Unit Price',
  'pages.service-config.detail.unit': 'Unit',
  'pages.service-config.detail.billingCycle': 'Billing Cycle',
  'pages.service-config.detail.status': 'Status',
  'pages.service-config.detail.batchCreate': 'Support Batch Create',
  'pages.service-config.detail.remarks': 'Remarks',
  'pages.service-config.detail.createdTime': 'Created Time',
  'pages.service-config.detail.updatedTime': 'Updated Time',
  'pages.service-config.detail.createdBy': 'Created By',
  'pages.service-config.detail.updatedBy': 'Updated By',
  'pages.service-config.detail.yes': 'Yes',
  'pages.service-config.detail.no': 'No',

  // Form
  'pages.service-config.form.editTitle': 'Edit Amount Configuration',
  'pages.service-config.form.createTitle': 'Create Amount Configuration',
  'pages.service-config.form.feeType.label': 'Fee Type',
  'pages.service-config.form.feeType.required': 'Please select fee type',
  'pages.service-config.form.feeType.placeholder': 'Please select fee type',
  'pages.service-config.form.icon.label': 'Icon',
  'pages.service-config.form.icon.required': 'Please select icon',
  'pages.service-config.form.icon.placeholder': 'Please select icon',
  'pages.service-config.form.name.label': 'Name',
  'pages.service-config.form.name.required': 'Please enter name',
  'pages.service-config.form.name.placeholder': 'Please enter configuration name',
  'pages.service-config.form.introduction.label': 'Introduction',
  'pages.service-config.form.introduction.required': 'Please enter introduction',
  'pages.service-config.form.introduction.placeholder': 'Please enter configuration introduction',
  'pages.service-config.form.sort.label': 'Sort',
  'pages.service-config.form.sort.required': 'Please enter sort value',
  'pages.service-config.form.sort.placeholder': 'Please enter sort value',
  'pages.service-config.form.sort.min': 'Sort value must be greater than or equal to 0',
  'pages.service-config.form.status.label': 'Status',
  'pages.service-config.form.status.required': 'Please select status',
  'pages.service-config.form.status.placeholder': 'Please select status',
  'pages.service-config.form.batchCreate.label': 'Support Batch Create',
  'pages.service-config.form.batchCreate.required': 'Please select whether to support batch create',
  'pages.service-config.form.select': 'Select',
  'pages.service-config.form.emojiPicker.title': 'Select Emoji Icon',

  // Status Options
  'pages.service-config.status.enabled': 'Enabled',
  'pages.service-config.status.disabled': 'Disabled',
  'pages.service-config.status.unknown': 'Unknown',

  // Batch Create Options
  'pages.service-config.batchCreate.yes': 'Yes',
  'pages.service-config.batchCreate.no': 'No',

  // Confirm Dialog
  'pages.service-config.confirm.ok': 'OK',
  'pages.service-config.confirm.cancel': 'Cancel',

  // Detail Page
  'pages.service-config.detail.page.title': 'Amount Configuration Details',
  'pages.service-config.detail.page.breadcrumb.config': 'Amount Configuration',
  'pages.service-config.detail.page.breadcrumb.detail': 'Details',
  'pages.service-config.detail.table.title': 'Amount Configuration Details List',
  'pages.service-config.detail.table.new': 'New',
  'pages.service-config.detail.table.confirmDelete': 'Are you sure you want to delete this record?',
  'pages.service-config.detail.table.batchDelete': 'Batch Delete',
  'pages.service-config.detail.table.confirmBatchDelete': 'Are you sure you want to delete the selected {count} records?',
  'pages.service-config.detail.table.deleteSuccess': 'Deleted successfully',
  'pages.service-config.detail.table.batchDeleteSuccess': 'Batch delete successful',
  'pages.service-config.detail.table.deleteFailed': 'Delete failed',
  'pages.service-config.detail.table.batchDeleteFailed': 'Batch delete failed',
  'pages.service-config.detail.table.getDetailFailed': 'Failed to get details',

  // Detail Table Columns
  'pages.service-config.detail.table.columns.feeType': 'Fee Type',
  'pages.service-config.detail.table.columns.name': 'Name',
  'pages.service-config.detail.table.columns.unitPrice': 'Unit Price',
  'pages.service-config.detail.table.columns.unit': 'Unit',
  'pages.service-config.detail.table.columns.sort': 'Sort',
  'pages.service-config.detail.table.columns.billingCycle': 'Billing Cycle',
  'pages.service-config.detail.table.columns.status': 'Status',
  'pages.service-config.detail.table.columns.batchCreate': 'Support Batch Create',
  'pages.service-config.detail.table.columns.createdTime': 'Created Time',
  'pages.service-config.detail.table.columns.operations': 'Operations',
  'pages.service-config.detail.table.columns.edit': 'Edit',
  'pages.service-config.detail.table.columns.delete': 'Delete',

  // Detail Form
  'pages.service-config.detail.form.editTitle': 'Edit Configuration',
  'pages.service-config.detail.form.createTitle': 'Create Configuration',
  'pages.service-config.detail.form.feeType.label': 'Fee Type',
  'pages.service-config.detail.form.feeType.required': 'Please select fee type',
  'pages.service-config.detail.form.feeType.placeholder': 'Please select fee type',
  'pages.service-config.detail.form.name.label': 'Name',
  'pages.service-config.detail.form.name.required': 'Please enter name',
  'pages.service-config.detail.form.name.placeholder': 'Please enter name',
  'pages.service-config.detail.form.unitPrice.label': 'Unit Price',
  'pages.service-config.detail.form.unitPrice.required': 'Please enter unit price',
  'pages.service-config.detail.form.unitPrice.placeholder': 'Please enter unit price',
  'pages.service-config.detail.form.unitPrice.min': 'Unit price cannot be less than 0',
  'pages.service-config.detail.form.unit.label': 'Unit',
  'pages.service-config.detail.form.unit.required': 'Please enter unit',
  'pages.service-config.detail.form.unit.placeholder': 'Please enter unit, e.g.: CNY/square meter, CNY/month, etc.',
  'pages.service-config.detail.form.billingCycle.label': 'Billing Cycle',
  'pages.service-config.detail.form.billingCycle.required': 'Please select billing cycle',
  'pages.service-config.detail.form.billingCycle.placeholder': 'Please select billing cycle',
  'pages.service-config.detail.form.sort.label': 'Sort',
  'pages.service-config.detail.form.sort.required': 'Please enter sort value',
  'pages.service-config.detail.form.sort.placeholder': 'Please enter sort value',
  'pages.service-config.detail.form.sort.min': 'Sort value must be non-negative',
  'pages.service-config.detail.form.status.label': 'Status',
  'pages.service-config.detail.form.status.required': 'Please select status',
  'pages.service-config.detail.form.status.placeholder': 'Please select status',
  'pages.service-config.detail.form.batchCreate.label': 'Support Batch Create',
  'pages.service-config.detail.form.batchCreate.required': 'Please select whether to support batch create',
  'pages.service-config.detail.form.updateSuccess': 'Updated successfully',
  'pages.service-config.detail.form.createSuccess': 'Created successfully',
  'pages.service-config.detail.form.submitFailed': 'Submit failed',

  // Billing Cycle Options
  'pages.service-config.billingCycle.monthly': 'Monthly',
  'pages.service-config.billingCycle.quarterly': 'Quarterly',
  'pages.service-config.billingCycle.yearly': 'Yearly',
  'pages.service-config.billingCycle.once': 'One-time',
  'pages.service-config.billingCycle.daily': 'Daily',

  // Fee Type Options
  'pages.service-config.feeType.property_fee': 'Property Fee',
  'pages.service-config.feeType.parking_fee': 'Parking Fee',
  'pages.service-config.feeType.water_fee': 'Water Fee',
  'pages.service-config.feeType.electricity_fee': 'Electricity Fee',
  'pages.service-config.feeType.gas_fee': 'Gas Fee',
  'pages.service-config.feeType.heating_fee': 'Heating Fee',
  'pages.service-config.feeType.maintenance_fee': 'Maintenance Fee',
  'pages.service-config.feeType.other': 'Other',
};
